import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import HttpClient from '../../utils/HttpClient'
import toast from 'react-hot-toast'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon'
import DataTable from 'react-data-table-component'
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal'
import { ImCross } from 'react-icons/im'
import { useDispatch } from 'react-redux'
import { fetchMemberUserData } from "../../Redux/Slice/Offer";



const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "35px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '24px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '18px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },

};

const OfferCategory = () => {
    const initData = {
        "categoryName": "",
        "categoryImage": ""
    }
    const [OfferCreate, setOfferCreate] = useState(initData)
    const [AllData, setAllData] = useState([]);
    const [isLoading, setisLoading] = useState(false)
    const [isEdit, setisEdit] = useState(false);
    const [OfferID, setOfferID] = useState("");
    const dispatch = useDispatch()


    // select the Image
    const handleChange = async (e) => {
        const { name, files } = e.target;
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setOfferCreate(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
            }
        }
    };

    //submit data
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!OfferCreate?.categoryImage || !OfferCreate?.categoryName) {
            return toast.error("Input Blank")
        }
        setisLoading(true)
        const data = OfferCreate


        const res = await HttpClient.requestData("offer-category", "POST", data)
        if (res && res?.status) {
            toast.success("Successfully created!")
            setisLoading(false)
            viewCategorys()
            setOfferCreate(initData)
        }
        else {
            toast.error("Can't Created");
            setisLoading(false)
            viewCategorys()
        }
    }

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "10%"
        },
        {
            name: 'Category Name',
            selector: row => row.categoryName,
            width: "40%"
        },
        {
            name: 'Category Image',
            selector: row => row.categoryImage,
            width: "30%"
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "20%"
        }



    ];
    //viewOffers 
    const viewCategorys = async () => {
        setisLoading(true);
        const res = await HttpClient.requestData("offer-category", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setisLoading(false);
            apiData = res?.data?.map((item, i) => ({

                sl: i + 1,
                categoryName: item?.categoryName,
                categoryImage: <img src={item?.categoryImage} className='w-25 mx-4 mt-1 mb-1' />,


                action: <EditDeleteIcon
                    onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />
            })

            );
        }
        else {
            setisLoading(false);
        }
        setAllData(apiData);
    }

    //delete offer
    const handleDelete = async (id) => {
        async function del() {
            setisLoading(true);
            const res = await HttpClient.requestData(`offer-category/${id}`, 'DELETE', {})
            if (res && res?.status) {
                toast.success('Category Deleted Successfully');
                setisLoading(false);
                viewCategorys()
            }
            else {
                toast.error('Cant Delete!')
                setisLoading(false);
                viewCategorys()
            }
        }
        DeleteConfirmModal(del)
    }
    //Edit
    const handleEdit = async (item) => {
        setisEdit(true)
        setOfferID(item?._id)
        setOfferCreate(prev => ({ ...prev, categoryName: item?.categoryName, categoryImage: item?.categoryImage }))


    }
    //cancel edit
    const cancelEdit = (e) => {
        setisEdit(false)
        setOfferCreate(initData)

    }
    //Edit Submit
    const handleEditSubmit = async (e) => {
        e.preventDefault()
        if (!OfferCreate?.categoryImage || !OfferCreate?.categoryName) {
            return toast.error("Input Blank")
        }
        setisLoading(true)
        const editFormData = OfferCreate;
        const res = await HttpClient.requestData(`offer-category/${OfferID}`, 'PUT', editFormData)

        if (res && res?.status) {
            toast.success("Item Edited Successfully");
            setisEdit(false)
            setisLoading(false)
            viewCategorys()
            setOfferCreate(initData)
        }
        else {
            setisLoading(false)
            toast.error(res?.message || "Something Wrong");
            setisLoading(false);
            viewCategorys()

        }
    }
    useEffect(() => {
        viewCategorys();
    }, [])
  

    return (
        <div>

            <CustomLoader
                loading={isLoading}
            />


            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            Add Offers Category
                        </div>
                        <form >
                            <div className="row">
                                <div className="col-md-12 mt-3 ">
                                    <label style={{ marginRight: "65px" }}>Offer Name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="banner"
                                        name="categoryName"
                                        value={OfferCreate.categoryName}
                                        onChange={(e) => setOfferCreate(prev => ({ ...prev, categoryName: e.target.value }))}
                                        required
                                    />



                                </div>
                                <div className="col-md-12 mt-3 ">
                                    <label style={{ marginRight: "22px" }}>Category Image: <span style={{ color:"red" }}>(300 x 185)</span></label>
                                   
                                    <input
                                        type="file"
                                        className="mx-1"
                                        placeholder="profilePhoto"
                                        name="categoryImage"
                                        // value={formFourthData.profilePhoto}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    />
                                    {OfferCreate?.categoryImage && <img src={OfferCreate?.categoryImage} alt="" id='preview' height="70px" width="70px" className='mb-2'
                                    // onClick={() => handleView(formFourthData?.profilePhoto)}
                                    />}
                                </div>

                            </div>

                            {!isEdit ? <Button variant="contained" color="primary" className='mx-2 mt-2' onClick={(e) => handleSubmit(e)}>
                                Submit
                            </Button> :
                                <div>
                                    <Button variant="contained" color="primary" className='mx-2 mt-2' onClick={(e) => handleEditSubmit(e)}>
                                        Update
                                    </Button>    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div>
                            }
                            {/* <ImageModal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)}
            SelectedImage={SelectedImage} /> */}
                        </form>
                        <div className='mt-2'>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded mt-1"
                                customStyles={customStyles}
                            />
                        </div>
                    </section>
                </div>

            </div >




        </div >
    )
}

export default OfferCategory